import { render, staticRenderFns } from "./download.vue?vue&type=template&id=0271f4b6&scoped=true&"
import script from "./download.vue?vue&type=script&lang=js&"
export * from "./download.vue?vue&type=script&lang=js&"
import style0 from "./download.vue?vue&type=style&index=0&id=0271f4b6&scoped=true&lang=less&"
import style1 from "./download.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0271f4b6",
  null
  
)

export default component.exports